//==============================
// Content Slider
//==============================

var contentSlider = $('.content-slider-items');

contentSlider.slick({
  autoplay: false,
  speed: 600,
  slidesToShow: 1,
  swipeToSlide: true,
  dots: true,
  arrows: true,
  centerMode: false,
  centerPadding: '10%',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        centerPadding: '5%'
      }
    }
  ]
});
